import { render, staticRenderFns } from "./StepFormsConfig.vue?vue&type=template&id=8185a34c&scoped=true&"
import script from "./StepFormsConfig.vue?vue&type=script&lang=js&"
export * from "./StepFormsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8185a34c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
